import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, ShieldCheck } from "lucide-react";

const CONTACT_EMAIL = "hello@sacredcrownstudio.com";
const INSTAGRAM_URL = "#";

export function PageHeader() {
  return (
    <header className="sticky top-0 z-50 bg-[#fdfbf7]/90 backdrop-blur-md border-b border-[#eae0d5]/70">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 sm:px-10">
        <Link to="/" data-testid="brand-mark" className="flex flex-col leading-tight">
          <span className="font-display text-base sm:text-lg tracking-[0.18em] text-[#7a5e36]">
            SACRED CROWN
          </span>
          <span className="font-display text-[10px] tracking-[0.45em] text-[#b89461]">
            STUDIO
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-9 text-[11px] tracking-[0.28em] uppercase text-[#5c544f]">
          <Link to="/" className="hover:text-[#b89461] transition-colors">Home</Link>
          <Link to="/services" className="hover:text-[#b89461] transition-colors">Services</Link>
          <Link to="/intake" className="hover:text-[#b89461] transition-colors">Intake</Link>
          <Link to="/gift-cards" className="hover:text-[#b89461] transition-colors">Gift Cards</Link>
        </div>
        <Link
          to="/intake"
          data-testid="header-book-button"
          className="inline-flex items-center rounded-sm bg-[#b89461] px-5 py-2.5 text-[10px] font-medium tracking-[0.28em] uppercase text-[#fdfbf7] transition-all duration-500 hover:bg-[#a07e4f]"
        >
          Book Your Session
        </Link>
      </nav>
    </header>
  );
}

export function PageFooter() {
  return (
    <footer className="bg-[#fdfbf7] border-t border-[#eae0d5] mt-20">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 py-14">
        <div className="grid gap-10 md:grid-cols-3 items-start">
          <div>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-base tracking-[0.18em] text-[#7a5e36]">SACRED CROWN</span>
              <span className="font-display text-[10px] tracking-[0.45em] text-[#b89461]">STUDIO</span>
            </div>
            <p className="mt-6 max-w-xs text-[13px] leading-[1.85] text-[#5c544f] font-light">
              You don&rsquo;t have to hold it all together here. This is your time to soften.
            </p>
          </div>
          <div className="space-y-4 text-[14px] text-[#3f3a35] font-light">
            <div className="flex items-start gap-3">
              <ShieldCheck size={16} strokeWidth={1.2} className="mt-1 text-[#b89461]" />
              <div>
                <p className="text-[11px] tracking-[0.3em] uppercase text-[#b89461]">Women only</p>
                <p>By appointment</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Mail size={16} strokeWidth={1.2} className="mt-1 text-[#b89461]" />
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#b89461] transition-colors">
                {CONTACT_EMAIL}
              </a>
            </div>
            <div className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.2} className="mt-1 text-[#b89461]" />
              <p>Los Angeles, CA</p>
            </div>
            <div className="pt-2">
              <a href={INSTAGRAM_URL} aria-label="Instagram" className="text-[#7a5e36] hover:text-[#b89461]">
                <Instagram size={18} strokeWidth={1.3} />
              </a>
            </div>
          </div>
          <div className="md:text-right">
            <p className="font-display italic text-lg text-[#2d2926] mb-6">
              Gentle touch. Deep rest. Lasting calm.
            </p>
            <Link
              to="/gift-cards"
              className="inline-flex items-center justify-center rounded-sm border border-[#b89461]/70 px-7 py-3 text-[11px] font-medium tracking-[0.28em] uppercase text-[#7a5e36] hover:bg-[#b89461]/10 transition-all"
            >
              Gift A Ritual
            </Link>
          </div>
        </div>
        <p className="mt-12 text-center text-[11px] tracking-[0.28em] uppercase text-[#b8ad9d]">
          © 2026 Sacred Crown Studio · All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
